import { Global, css } from "@emotion/react";
import {fontWeight, fontFamily, text} from "@atlas-int/tokens";

const globalStyles = css`
  .trade-methodology-page {
    font-family: "${fontFamily.base}", sans-serif;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  .trade-methodology-page p a,
  .trade-methodology-page li a {
    color: ${text.content};
  }

  .trade-methodology-page p a:hover,
  .trade-methodology-page li a:hover {
    color: ${text.link};
  }

  /* Override for navigation bar */
  .trade-methodology-page .navigation-bar li a {
    color: ${text.onDark};
  }

  .trade-methodology-page .navigation-bar li a:hover {
    color: ${text.onDark};
  }

  .trade-methodology-page .proposed-revision {
    background-color: #fffee6;
    color: ${text.secondary};
  }

  .trade-methodology-page .bold {
    font-weight: ${fontWeight.semibold};
  }

  .trade-methodology-page .italic {
    font-style: italic;
    font-family: "${fontFamily.base}", sans-serif;
    font-weight: ${fontWeight.normal};
  }

  .trade-methodology-page .underline {
    text-decoration: underline;
  }
`;

export default function GlobalStyles() {
  return <Global styles={globalStyles} />;
}
